<template>
  <div class="border">
    <Form :label-width="100" :model="rentData" :rules="formRules" ref="form">

      <FormItem label="租期方式" prop="rentType">
        <Select v-model="rentData.rentType" @on-change="changeRentType" v-if="createContractData" class="width3">
          <Option v-for="(item,index) in createContractData.leaseTime" :value="item.value"
                  :key="'keyA'+index">
            {{item.text}}
          </Option>
        </Select>
      </FormItem>

      <FormItem label="租期时间" prop="conStartDate">
        <Row>
          <Col span="8" style="width:158px; padding-left:0; padding-right:0">
            <DatePicker type="date" placeholder="起租日" v-model="rentData.conStartDate"
                        @on-change="setreservationSignDate" :options="option0"></DatePicker>
          </Col>
          <Col span="8" style="width:164px; padding-left:8px; padding-right:0">
            <FormItem prop="conEndDate" style="">
              <DatePicker v-if="rentData.rentType === 1" type="date"
                          v-model="rentData.conEndDate" :options="options1" placeholder="退租日"
                         ></DatePicker>
              <DatePicker type="date"
                          v-if="rentData.rentType === 2" :start-date="options2.minTime"
                          v-model="rentData.conEndDate" :options="options2" placeholder="退租日"
                         ></DatePicker>
              <DatePicker v-if="rentData.rentType===0" v-model="rentData.conEndDate" disabled
                         ></DatePicker>

            </FormItem>
          </Col>
          <Col span="8">
            <div class="time-box" v-if="rentData.rentType === 1 && year ">{{year}}年</div>
            <div class="time-box" v-if="rentData.rentType === 2 && monthAndDay.month">{{monthAndDay.month}}月
            </div>
            <div class="time-box" v-if="rentData.rentType ===2 && monthAndDay.day">{{monthAndDay.day}}天</div>
          </Col>
        </Row>
      </FormItem>

      <FormItem label="预计签约日期" prop="reservationSignDate">
        <DatePicker class="width3" disabled v-model="rentData.reservationSignDate" type="date"
                    placeholder=""></DatePicker>
      </FormItem>

      <FormItem label="收取定金" prop="depositAccount">
        <Input class="width3" v-model="rentData.depositAccount" @on-blur="calculation"></Input>
        <span>元</span>
      </FormItem>
      <FormItem label="预订房租" prop="houseRentPrice">
        <Input class="width3" disabled v-model="rentData.houseRentPrice"></Input>
        <span>元/月</span>
        <span class="error-color">（实际租金基于付款方式会有上下浮动）</span>
      </FormItem>

    </Form>
  </div>
</template>
<script>
  import {formatDateTime} from "../../../../../utils/format";

  export default {
    components: {},
    props: {
      data: {
        type: Object,
        default: null
      },
      createContractData: {
        type: Object,
        default: null
      }
    },
    watch:{
      createContractData: {
        deep: true,
          handler(val) {
          this.rentData.houseRentPrice=val.stockRentPrice
            this.rentData.depositAccount=val.depositStandard
        }
      }


    },
    computed: {
      option0(){
        if(!this.createContractData){
          return {}
        }
        let data=this.createContractData.roomCanRent
        return {
          disabledDate(date) {
            return date && (date.valueOf() < data.minReservationSignDate-86399999 || date.valueOf() > data.maxReservationSignDate);
          }

        }

      },
      monthAndDay() {
        let ret = {
          month: '',
          day: ''
        }
        if (!this.rentData.conStartDate || !this.rentData.conEndDate || (this.rentData.rentType === 1)) {
          return ret
        }
        let year1 = this.rentData.conStartDate.getFullYear()
        let month1 = this.rentData.conStartDate.getMonth()
        let day1 = this.rentData.conStartDate.getDate()
        let year2 = this.rentData.conEndDate.getFullYear()
        let month2 = this.rentData.conEndDate.getMonth()
        let day2 = this.rentData.conEndDate.getDate()
        let lasttmonthdays = new Date(year2, month2, 0).getDate()
        let diffM = month2 - month1
        let diffD = day2 - day1

        if (year1 === year2) {
          if (diffD >= 0) {
            ret.day = diffD + 1
            ret.month = month2 - month1
          } else if(diffD===-1){
            ret.day = 0
            ret.month = diffM
          }else {
            ret.day = diffD + lasttmonthdays + 1
            ret.month = diffM - 1
          }
        }
        else {
          if (diffD >= 0) {
            ret.day = diffD + 1
            ret.month = diffM + 12
          } else if(diffD===-1){
            ret.day = 0
            ret.month = diffM + 12

          } else {
            ret.day = diffD + lasttmonthdays + 1
            ret.month = diffM + 12 - 1
          }
        }
        return ret
      },
      options1() {
        if (!this.createContractData || !this.rentData.conStartDate) {
          return {}
        }
        let shortcuts = []
        let year = this.rentData.conStartDate.getFullYear()
        let month = this.rentData.conStartDate.getMonth()
        let date = this.rentData.conStartDate.getDate()
        let min = this.createContractData.roomCanRent.minRentYear
        let max = this.createContractData.roomCanRent.maxRentYear
        let stockMaxSignDate = this.createContractData.roomCanRent.stockMaxSignDate
        let _this = this

        for (let i = min; i <= max; i++) {
          // console.log(year+i,month+1,date-1)
          let num1 = (new Date(year + i, month, date - 1)).valueOf()
          if (num1 > Number(stockMaxSignDate)) {
            break;
          }
          shortcuts.push({
            text: i + '年',
            value() {
              return (year + i) + '-' + (month + 1) + '-' + (date - 1)
            },
            onClick: (picker) => {
              _this.year = i
            }
          })
        }
        return {
          shortcuts: shortcuts,
          disabledDate() {
            return true
          }
        }

      },
      options2() {
        if (!this.createContractData || !this.rentData.conStartDate) {
          return {}
        }
        let max = this.createContractData.roomCanRent.maxRentDay
        let min = this.createContractData.roomCanRent.minRentDay
        let stockMaxSignDate = Number(this.createContractData.roomCanRent.stockMaxSignDate)

        let minTime = this.rentData.conStartDate.valueOf() + 3600 * 24 * 1000 * (min - 1)
        let maxTime = this.rentData.conStartDate.valueOf() + 3600 * 24 * 1000 * (max - 1)
        minTime = minTime > stockMaxSignDate ? stockMaxSignDate : minTime
        maxTime = maxTime > stockMaxSignDate ? stockMaxSignDate : maxTime

        return {
          disabledDate(date) {
            return date && date.valueOf() < minTime || date.valueOf() > maxTime;
          },
          minTime: new Date(minTime)
        }
      }


    },
    data() {
      return {
        rentData: {
          rentType: '',
          conEndDate: '',
          reservationSignDate: '',
          depositAccount: '',
          houseRentPrice: '',
          conStartDate: "",

        },
        formRules: {
          rentType: [{required: true, type: 'number', message: ' ', trigger: 'change'}],
          conEndDate: [{required: true, message: ' ', trigger: 'change', type: 'object'}],
          conStartDate: [{required: true, message: ' ', trigger: 'change', type: 'object'}],

          reservationSignDate: [{required: true, message: ' ', trigger: 'change', type: 'object'}],
          depositAccount: [{required: true, trigger: 'blur', message: ' ', validator: this.validateNumber2}],
          houseRentPrice: [{required: true, trigger: 'blur', message: ' ', validator: this.validateNumber2}]
        },
        responseDate: null,
        projectName: '',
        // phone: '',
        // conEndDate: ''
      }
    },
    methods: {
      setDate(value, num) {
        let date = new Date(value);
        // if (date) {
        let year = date.getFullYear() + num
        let month = date.getMonth()
        let day = date.getDate() - 1
        return new Date(year, month, day)
        // }
      },
      setreservationSignDate(value){
        console.log('=====')
        // this.rentData.reservationSignDate=value
        // if(this.rentData.conType!==0){
        //   this.rentData.conEndDate=''
        // }
        this.year = 0
        this.rentData.reservationSignDate=value

        if (this.rentData.rentType === 0 || !this.createContractData) {
          return
        }
        if (!value) {
          this.rentData.conEndDate=''
          return

        }
        if (this.rentData.rentType === 2) {

          let data = new Date(value).valueOf() + 3600 * 24 * 1000 * (this.createContractData.roomCanRent.minRentDay - 1)
          this.rentData.conEndDate = new Date(data)

        }
        if (this.rentData.rentType === 1) {

          this.year = this.createContractData.roomCanRent.minRentYear
          this.rentData.conEndDate = this.setDate(value, this.createContractData.roomCanRent.minRentYear)


        }
      },
      changeRentType(value) {
        if (value === 0) {
          this.rentData.conEndDate = new Date(this.createContractData.roomCanRent.stockMaxSignDate)
        }
        else {
          this.rentData.conEndDate = ''

        }
        this.year = 0
      },
      validate() {
        let re = null
        this.$refs['form'].validate(bool => {
          re = bool
        })
        return re
      },
      validateNumber2(rule, value, callback) {
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      init() {
        this.cleanData()

      },

      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, false)

      },
      calculation(){
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(this.formData.depositAccount)) {
          this.$Message.error('请输入正确的定金金额')
          this.formData.depositAccount = 0
        }
        this.formData.depositAccount = parseInt(this.formData.depositAccount)
      },
      cleanData() {
        this.$refs['form'].resetFields()
        this.rentData = {
          rentType: '',
          conEndDate: '',
          reservationSignDate: '',
          depositAccount: this.createContractData?this.createContractData.depositStandard:'',
          houseRentPrice: this.createContractData?this.createContractData.stockRentPrice:'',
          conStartDate: "",
        }
      },
      changeType(value) {
        if (value === 0) {
          this.rentData.conEndDate = this.stockMaxSignDate
        } else {
          this.rentData.conEndDate = ''
        }
        this.year = ''
      },
    }

  }
</script>

<style scoped>
  .left, .right {
    display: inline-block;
    line-height: 2.5;
  }

  .left {
    width: 100px;
    /*text-align: right;*/
    margin-left: 20px;
  }

  .inputwidth {
    width: 200px;
  }

  .width3 {
    width: 158px !important;
    display: inline-block;
  }

  .border {
    border-top: 1px solid #DDDEE1;
    padding-top: 20px;
  }
  .time-box {
    margin-left: 8px;
    display: inline-block;
    padding-left: 8px;
    padding-right: 8px;
    line-height: 30px;
    border: 1px solid #DDDEE1;
    border-radius: 2px;
  }

</style>
